import {ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractPasswordInput} from "../abstract-password-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlinePasswordInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-password-input",
    styleUrls: ["./inline-password-input.component.scss"],
    templateUrl: "./inline-password-input.component.html"
})
export class FUIInlinePasswordInputComponent extends FUIAbstractPasswordInput {

    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }
}
